import React from "react";
import GroupLogo from "../assets/images/17th.png";
import BeaverLogo from "../assets/images/beavers_logo.png";
import CubLogo from "../assets/images/cubs_logo.png";
import ScoutLogo from "../assets/images/scouts_logo.png";

function Sections() {
  return (
    <section id="sections">

      <img src={GroupLogo} alt="Scarf"/>

      <div className="homepage-sections-container">

        <div className="section-item">
          <a href="beavers.html#beavers">
            <img src={BeaverLogo} alt="Beavers"/>
          </a>
          <p>6 - 8 Years</p>
          <p>Term-time Tuesdays 4:45 - 6:00pm</p>
        </div>

        <div className="section-item">
          <a href="cubs.html#cubs">
            <img src={CubLogo} alt="Cubs"/>
          </a>
          <p>8 - 10½ Years</p>
          <p>Term-time Tuesdays 6:15 - 7:30pm</p>
        </div>

        <div className="section-item">
          <a href="scouts.html#scouts">
            <img src={ScoutLogo} alt="Scouts"/>
          </a>
          <p>10½ - 14 Years</p>
          <p>Term-time Tuesdays 7:45 - 9:15pm</p>
        </div>

      </div>
    </section>
  );
}

export default Sections;